define('views/autocomplete',["require", "exports", "../util/pubsub", "./dropdownlist"], function (require, exports, pubsub_1, dropdownlist_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Autocomplete = void 0;
    var Autocomplete = /** @class */ (function () {
        function Autocomplete(options) {
            var _this = this;
            // Subscribe for updates
            this.updates = new pubsub_1.PubSub();
            this.options = options;
            this.dropdown = new dropdownlist_1.DropdownList({
                input: options.input,
                display: options.display,
                onClick: function (item) {
                    // insert the value for the autocomplete text field
                    options.input.value = _this.options.value(item);
                    options.input.dispatchEvent(new Event("change"));
                    // Notify listeners
                    _this.updates.post(item);
                }
            });
            // Setup event listeners
            options.input.addEventListener("focus", function () { return _this.onInput(); });
            options.input.addEventListener("input", function () { return _this.onInput(); });
        }
        Autocomplete.prototype.onInput = function () {
            var text = this.options.input.value.trim();
            if (text.length < this.options.minLength) {
                this.dropdown.close();
                return;
            }
            // Update items
            var filtered = this.filterItems(text);
            this.dropdown.update(filtered);
        };
        // Return items filtered by query string
        Autocomplete.prototype.filterItems = function (query) {
            var _this = this;
            return this.options.items
                .filter(function (i) {
                var filter = _this.options.filter(i);
                if (typeof filter === "string") {
                    return filter.toLowerCase().indexOf(query.toLowerCase()) >= 0;
                }
                else {
                    return filter;
                }
            });
        };
        return Autocomplete;
    }());
    exports.Autocomplete = Autocomplete;
});
//# sourceMappingURL=/assets/javascripts/views/autocomplete.js.map;
